module.exports = __webpack_public_path__ + "media/the_future_of_autopilot_1.417beee3.mp4";